import React, { useState, useEffect, lazy, Suspense } from 'react';
import { connect } from 'react-redux';
import setScreen from '../../utils/screenTransistion';
import abcfLogo from "../../assets/images/abcf-logo.jpeg"
import "./styles.css";
const Registration = lazy(() => import('../registration'));
const CurrentComponent = lazy(() => import('../currentcomponent'));

const GameStart = ({
  currentScreen,
  messages,
  levels,
  shuffleData,
  images,
  isFeedbackRequired,
}) => {
  console.log("🚀 ~ currentScreen:", currentScreen)
  const [component, setComponent] = useState(<Registration />);
  const [imageClass, setImageClass] = useState("logo");


  const introList = ["", "INTIAl_LOADING", "PRE_GAME_INTRO", "PRE_GAME_ASHER_INTRO", "PRE_GAME_AVATAR_SELECTION"]

  useEffect(() => {
    setScreen(
      currentScreen,
      setComponent,
      component,
      messages,
      levels,
      images,
      isFeedbackRequired
    );
      
    if (introList.includes(currentScreen)) {
      setImageClass("logo");
    } else {
      setImageClass("logo gameplay"); 
    }


    // eslint-disable-next-line
  }, [currentScreen, shuffleData]);


  return (
    <>
      <Suspense fallback={<div>Loading</div>}>
        <img class= {imageClass} src={abcfLogo} alt='logo-aditya-birla'/>
        <CurrentComponent>{component}</CurrentComponent>
      </Suspense>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    shuffleData: state.shuffleData,
    isSubmitted: state.trackingUser.isSubmitted,
    isLoaded: state.trackingUser.isLoaded,
    messages: state.shuffleData.narrationDataSet.narrationDataList,
    currentScreen: state.screenChange.screenID,
    levels: state.shuffleData.levels,
    images: state.shuffleData.imageDataSet.imageDataList,
    isFeedbackRequired: state.intialize.isFeedbackRequired,
  };
};

export default connect(mapStateToProps)(GameStart);
